const roleMapping = {
  'branch-ops': 'BranchOps',
  'transaction-view': 'TransactionView',
  'finance-payable': 'FinancePayable',
  'finance-recievable': 'FinanceReceivable',
  'finance-recon': 'FinanceRecon',
  'partner-exec-manager': 'PartnerExecManager',
  'tracking-role': 'TrackingRole',
};

const mapRole = activeRole => roleMapping[activeRole] || activeRole;

export default mapRole;

/**
 * Picks the role a user may claim on the wire.
 *
 * Office-Web sends every Admin to the Ops dashboard and sets activeRole to
 * 'ops' (InitialPage.jsx, OpsDashboard.jsx), and the UI gates stay keyed on
 * that value. NH-PY and the Lambdas, however, refuse any role the user does
 * not actually hold, so an Admin who is not also Ops must identify as Admin
 * when talking to them. Users who hold Ops keep sending Ops, unchanged.
 * @param {string} mappedRole - Role after mapRole(), e.g. 'ops'.
 * @param {object} userDetails - Firestore Users doc of the signed-in user.
 * @returns {string} Role to send, before the 'is' prefix is applied.
 */
export const apiRoleForUser = (mappedRole, userDetails) => {
  if (
    mappedRole === 'ops' &&
    userDetails &&
    userDetails.isOps !== true &&
    userDetails.isAdmin === true
  ) {
    return 'Admin';
  }
  return mappedRole;
};

const currentUserDetails = () => {
  try {
    // Required lazily so this helper can be imported before the store exists
    // and so no import cycle forms through the views that use it.
    // eslint-disable-next-line global-require
    const store = require('../store').default;
    return store.getState().main.userDetails;
  } catch (e) {
    return undefined;
  }
};

export const mappedCurrentActiveRole = (
  activeRole,
  userDetails = currentUserDetails()
) => {
  const mapped = apiRoleForUser(mapRole(activeRole), userDetails);
  if (!mapped) return '';
  return `is${mapped.charAt(0).toUpperCase()}${mapped.slice(1)}`;
};
